<template>
    <qc-container :title="addRow.id?'修改用户':'添加用户'" :show-divider="true" v-loading="loading" >
      <el-form autocomplete="off" ref="ruleForm" :model="addRow" :rules="rules" label-width="120px" >
        <div class="hidden-input">
          <input type="text" class="form-control">
          <input type="password" class="form-control">
        </div>
        <el-form-item class="row" label="用户名" prop="userName" >
          <el-input placeholder="请输入用户名" :diabled="readonly"   auto-complete="off" class="w300" v-model="addRow.userName"  ></el-input>
        </el-form-item>
        <el-form-item class="row" label="密码" prop="password">
          <el-input  class="w300" type="password" v-model="addRow.password" auto-complete="new-password" placeholder="请输入密码"  ></el-input>
        </el-form-item>
        <el-form-item class="row" label="所属角色" prop="roleId">
          <el-select class="w300" v-model="addRow.roleId" placeholder="请选择角色">
            <el-option v-if="groupList&&groupList.length>0"
                       v-for="item in groupList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="row" label="昵称" prop="nickName">
          <el-input  placeholder="请输入昵称" class="w300"  v-model="addRow.nickName"  ></el-input>
        </el-form-item>
        <el-form-item class="row" label="手机号码" prop="mobile">
          <el-input  placeholder="请输入手机号码" class="w300"  v-model="addRow.mobile"  ></el-input>
        </el-form-item>
        <el-form-item class="row" label="描述" prop="remark">
          <el-input
            type="textarea"
            :rows="4"
            class="w600"
            placeholder="请输入描述"
            v-model="addRow.remark"></el-input>
        </el-form-item>
        <el-form-item class="flex-start">
          <el-button  @click="submitForm('ruleForm')">保存</el-button>
          <el-button  @click="returnLast">返回</el-button>
        </el-form-item>
      </el-form>
      <form method="post" id="addUserForm">
        <input type="hidden" v-model="addRow.userName" name="userName"/>
        <input type="hidden" v-model="addRow.password" name="password"/>
        <input type="hidden" v-model="addRow.roleId" name="roleId"/>
        <input type="hidden" v-model="addRow.remark" name="remark"/>
        <input type="hidden" v-model="addRow.nickName" name="nickName"/>
        <input type="hidden" v-model="addRow.mobile" name="mobile"/>
        <input type="hidden" v-model="addRow.source" name="source"/>
        <div v-show="false">
          <button id="createBt"> </button>
        </div>
      </form>
    </qc-container>
</template>

<script>
  import '../../../../static/plugin/jquery.form'
  import '../../../../static/plugin/jquery.jcryption.3.1.0'
  import QcContainer from "../../../components/el/layout/qc-container";

  export default {
    name: "UserAdd",
    components: {QcContainer},
    data() {
      return {
        loading: false,
        addRow: {id:'',userName: '',nickName:'', password: '', roleId: '', remark: '',source:source},
        groupList: [],
        rules: {
          userName: [
            {required: true, message: '请输入用户名', trigger: 'blur'},
            {min: 5, max: 16, message: '长度在 5 到 16 个字符', trigger: 'blur'}
          ],
          password: [
            {required: true, message: '请输入密码', trigger: 'blur'},
            {min: 5, max: 16, message: '长度在 5 到 16 个字符', trigger: 'blur'}
          ],
          nickName:[
            {max: 20, message: '长度不可超过 20 个字符', trigger: 'blur'}
          ],
          roleId: [
            {required: true, message: '请选择用户组', trigger: 'change'}
          ],
          mobile:[
            {pattern: mobilePass, message: '请输入正确的手机号码',trigger: 'blur'}
          ],
        },
        readonly:false,
      }
    },
    mixins:[tableBase],
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            $('#createBt').trigger('click')
          }
        });
      },
    },
    mounted() {
      this.simpleGet(Api.userGroup+"getRoleList", {source:source}, result => {
        this.groupList = result.data;
      });

      $('#addUserForm').attr('action', baseURL + '/api/mgr/user/addOrUpdate');

      this.initJCryption("#addUserForm","#createBt",()=>{
        this.returnLast();
      });
      if(this.$route.query&&this.$route.query.id){
        this.addRow.id = this.$route.query.id;
        this.simpleGet(Api.user+"detail", {id:this.addRow.id}, result => {
          this.addRow = result.data;
          this.readonly  = true;
          $("#addUserForm").append("<input type='hidden' name='id' value='"+this.addRow.id+"' />");
        });
      }
    }
  }
</script>


<style lang="less" scoped>
  input:-webkit-autofill {
    box-shadow: 0 0 0px 1000px white inset;
    -webkit-box-shadow: 0 0 0px 1000px white inset;
  }


</style>
